<template>
  <carousel-3d
    :controls-visible="true"
    :clickable="true"
    @after-slide-change="onAfterSlideChange"
  >
    <slide v-for="(slide, i) in slides" :index="i" v-bind:key="i">
      <figure>
        <div v-if="i == activeIndex" class="player">
          <iframe
            :src="`https://www.youtube.com/embed/${slide.youtube_id}`"
            frameborder="0"
            webkitAllowFullScreen="1"
            mozallowfullscreen="1"
            allowFullScreen="1"
          ></iframe>
        </div>
        <img :src="slide.img" />
        <figcaption v-html="slide.txt"></figcaption>
      </figure>
    </slide>
  </carousel-3d>
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "VideoSlider",
  data: function() {
    return {
      slides: window.videosliderAppConf.items,
      activeIndex: 0,
    };
  },

  methods: {
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.activeIndex = index;
    },
  },
  components: {
    Carousel3d,
    Slide,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.carousel-3d-slide {
  background: rgba(#777, 1);
}
.carousel-3d-container figure {
  margin: 0;
  position: relative;
  .player {
    // border: 1px solid red;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .player iframe,
  .player object,
  .player embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.carousel-3d-container figcaption {
  // background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  bottom: -60px;
  padding: 15px;
  font-size: 1.1rem;
  min-width: 100%;
  box-sizing: border-box;
}
</style>
